import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 px-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-lg leading-6 font-medium" }, "Terms and conditions"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 mt-1" }, "We need that to ensure you’re polite with our borrowers.")
], -1)
const _hoisted_2 = { class: "flex px-5 py-4 justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Not accepted", -1)
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Terms accepted", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_BadgeCheckIcon = _resolveComponent("BadgeCheckIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white shadow-sm rounded-md divide-y", {
      'ring-2 ring-red-500': !_ctx.termsAccepted,
      'ring-2 ring-green-500': _ctx.termsAccepted
    }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.termsAccepted)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ExclamationCircleIcon, { class: "w-6 h-6 text-red-500 mr-2" }),
              _hoisted_4
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "bg-sky text-white rounded-md text-sm px-3 py-1.5",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('ModalTermsAndConditions')))
            }, " Review terms & agree ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_BadgeCheckIcon, { class: "w-6 h-6 text-green-500 mr-2" }),
              _hoisted_6
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "bg-sky text-white rounded-md text-sm px-3 py-1.5",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal('ModalTermsAndConditions')))
            }, " Review terms ")
          ], 64))
    ])
  ], 2))
}